module.exports = __webpack_public_path__ + "img/Group 342931@2x.26a71b64.png";